import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';

import RichTextRenderer from '../components/Helpers/RichTextRenderer';
import Layout from '../components/Layout';
import QuizIntro from '../components/QuizIntro';
import { QuizScoreProvider } from '../store';


import { FrameSection, Quiz } from '../styles';

const QuizPageComponent = ({ data }) => {
  const { heading, customMessage } = data.contentfulQuizPage;
  const quizStartButtonText = "Start Quiz";
  const [introCompleted, setIntroCompleted] = React.useState(false);

  React.useEffect(() => {
    const body = document.querySelector('body');
    const computedStyles = window.getComputedStyle(body);
    window.parent.postMessage({
      action: 'wordpress-iframe-height',
      height: computedStyles['height'],
    }, "*");
  }, []);

  return (
    <Layout themeName="quizHomeTheme">
      <QuizScoreProvider>
        <FrameSection>
          <Quiz>
            <Quiz.TitleBox>{heading}</Quiz.TitleBox>
            <Quiz.MessageBox>
              {documentToReactComponents(customMessage.json, RichTextRenderer)}
            </Quiz.MessageBox>
            <QuizIntro setIntroCompleted={setIntroCompleted} />
              <Quiz.Button
                disabled={!introCompleted}
                to={introCompleted ? '/start-quiz' : ''}
              >
                {quizStartButtonText}
            </Quiz.Button>
          </Quiz>
        </FrameSection>
      </QuizScoreProvider>

    </Layout>
  );
}

const { any } = PropTypes;
QuizPageComponent.propTypes = {
  data: any,
}

export default QuizPageComponent;

// TODO: add subtitle and button text
export const query = graphql`
  query QuizPageQuery {
    contentfulQuizPage {
      heading
      customMessage {
        json
      }
      questions {
        id
      }
    }
  }
`;
